export default __webpack_public_path__ + "static/Case-Deal-891e3ae8bc360ba0e2c42a78e52703e9.png";